import React, { useEffect } from 'react';
import { TopBar } from '../components/Layout';
import { ReaderPings } from '../components/ReaderPings';
import { trackFb } from '../lib/fbpixel';
import { Hero, EditorialStance, Mystery } from '../components/Sections';
import { WhatsIncluded, Volumes, InsideLook, IncludedInvestigations, WhyWorthIt } from '../components/ContentSections';
import { Offer, Guarantee, FAQ, FinalCTA } from '../components/ConversionSections';
export function LandingPage() {
  useEffect(() => {
    trackFb('ViewContent', {
      content_name: 'NOS MIENTEN',
      content_type: 'product',
      currency: 'USD',
      value: 9.99
    });
  }, []);
  return <div className="min-h-screen bg-brand-dark flex flex-col font-sans selection:bg-brand-gold selection:text-brand-dark" data-id="element-137" data-mp="2fzno3pikv8q2">
      <TopBar data-id="element-138" data-mp="qk7giekaxv2a" />

      <main className="flex-1" data-id="element-139" data-mp="qlqws55yk642">
        <Hero data-id="element-140" data-mp="qkzbpo9zlqs1" />
        <EditorialStance data-id="element-141" data-mp="qmk5hboh95ou" />
        <Mystery data-id="element-142" data-mp="lm5w9qb53pp8" />
        <WhatsIncluded data-id="element-143" data-mp="lmo31gvfhmbe" />
        <Volumes data-id="element-144" data-mp="ln7c0833p0da" />
        <InsideLook data-id="element-145" data-mp="lnpazch5dsow" />
        <IncludedInvestigations data-id="element-146" data-mp="2zj6yz5fkhp5q" />
        <WhyWorthIt data-id="element-147" data-mp="2zjyivizsxyg6" />
        <Offer data-id="element-148" data-mp="2zki00xhmoit5" />
        <Guarantee data-id="element-149" data-mp="2zguae9fb0gjp" />
        <FAQ data-id="element-150" data-mp="33kiiqubrfg60" />
        <FinalCTA data-id="element-151" data-mp="33k0og38nrc0q" />
      </main>

      <footer className="bg-brand-anthracite py-8 border-t border-brand-card text-center px-5" data-id="element-152" data-mp="33lbnxqv2lxm1">
        <p className="text-brand-muted text-xs" data-id="element-153" data-mp="38itrt2u8dmn6">
          &copy; {new Date().getFullYear()} Nos Mienten. Todos los derechos
          reservados.
        </p>
      </footer>

      <ReaderPings data-id="element-154" data-mp="3ia7wrq4ybenp" />
    </div>;
}